/** Renderer lookup by platform. Adding iOS later is a directory plus one register(). */
import type { PreviewApiType } from '@/api/mobilePreview';
import type { Renderer, RendererId } from './types';

const REGISTRY = new Map<RendererId, Renderer>();

export function registerRenderer(renderer: Renderer): void {
  REGISTRY.set(renderer.id, renderer);
}

export function getRenderer(id: RendererId): Renderer | undefined {
  return REGISTRY.get(id);
}

export function renderersFor(apiType: PreviewApiType): Renderer[] {
  return [...REGISTRY.values()].filter((r) => r.supports(apiType));
}

export function allRenderers(): Renderer[] {
  return [...REGISTRY.values()];
}
